/**
 * Tracks keyboard vs mouse/touch interactions and applies .keyboard-focus class
 * to elements that receive focus via keyboard navigation.
 *
 * This provides more reliable focus styling than :focus-visible, especially
 * for inputs and textareas which can incorrectly show focus-visible on mouse clicks.
 */

let lastInteractionType = null;

const KEYBOARD_NAVIGATION_KEYS = ['Tab', 'ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight', 'Enter', ' ', 'Escape'];

const removeKeyboardFocusClass = () => {
  document.querySelectorAll('.keyboard-focus').forEach(el => {
    el.classList.remove('keyboard-focus');
  });
};

const handleFocusIn = e => {
  removeKeyboardFocusClass();

  if (lastInteractionType === 'keyboard') {
    e.target.classList.add('keyboard-focus');
  }
};

const handleFocusOut = () => {
  setTimeout(() => {
    if (document.activeElement === document.body || !document.activeElement) {
      removeKeyboardFocusClass();
    }
  }, 10);
};

export const initKeyboardFocusTracking = () => {
  document.addEventListener(
    'mousedown',
    () => {
      lastInteractionType = 'mouse';
    },
    true,
  );

  document.addEventListener(
    'touchstart',
    () => {
      lastInteractionType = 'touch';
    },
    true,
  );

  document.addEventListener(
    'keydown',
    e => {
      if (KEYBOARD_NAVIGATION_KEYS.includes(e.key)) {
        lastInteractionType = 'keyboard';
      }
    },
    true,
  );

  document.addEventListener('focusin', handleFocusIn, true);
  document.addEventListener('focusout', handleFocusOut, true);
};
